<!-- notification-bell.component.html -->
<div class="notification-bell">
    <button mat-icon-button (click)="onNotificationClick()" 
    [matTooltip]="'Έχετε ' + (notificationCount$ | async) + ' παραγγελίες σε εκκρεμότητα'"
    matTooltipClass="my-custom-tooltip"
    matTooltipPosition="above">
      <mat-icon>notifications</mat-icon> <!-- Angular Material bell icon -->
      <span *ngIf="notificationCount$ | async as notificationCount" class="notification-badge">
        {{ notificationCount }}
      </span>
    </button>
</div> 
  